module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-10.aa8e412b.webp";